/* eslint-disable jsx-a11y/anchor-is-valid */
import { Navbar } from "react-bootstrap";
import React from "react";
import { withRouter } from "react-router-dom";

import Button from "../../elements/CustomButton/CustomButton";


const SuperpositionHeader = ({ backBtnText, children, backUrl, history, handleMinimizeSidebar, transparent }) => {
  const mobileSidebarToggle = e => {
    document.documentElement.classList.toggle("nav-open");
  };

  // let sidebarMini = document.body.classList.contains("sidebar-mini");
  // console.log("sidebarMini=", sidebarMini);
  //style={{ width: sidebarMini?"calc(100vw - 30px)":"calc(100vw - 260px)"}}>

  /*
          <button
            id="minimizeSidebar"
            className="btn btn-icon btn-round btn-default btn-fill"
            onClick={this.props.handleMinimizeSidebar}
          >
            <i className="fa fa-ellipsis-v visible-on-sidebar-regular" />
            <i className="fa fa-navicon visible-on-sidebar-mini" />
          </button>
  */

  let style1 = { borderBottom: "Inerit", backgroundColor: "Inerit" };
  let style2 = { position: "sticky", width: "auto", marginBottom: "12px" };

  if (transparent === true) {
    style1 = { borderBottom: "1px solid rgba(0, 0, 0, 0)", backgroundColor: "transparent" };
    style2 = { position: "sticky", width: "auto", marginBottom: "inherit" };
  }

  return (
    <div
      className="superposition-header"
      //style={{ width: sidebarMini?"calc(100vw - 30px)":"calc(100vw - 260px)"}}
      style={style2}>

      <Navbar fluid style={style1} >
        <Navbar.Header className="header-content">
          <Navbar.Brand >
            <div
              className="header-content-width space-between align-items-center"
              style={{ marginLeft: "0px" }}
            >
              <div className="space-between">
                {handleMinimizeSidebar ? (
                  <div style={{ marginRight: "12px" }}>
                    <button
                      id="minimizeSidebar"
                      className="btn btn-icon btn-round btn-fill"
                      onClick={handleMinimizeSidebar}
                    >
                      <i className="fa fa-ellipsis-v visible-on-sidebar-regular" />
                      <i className="fa fa-navicon visible-on-sidebar-mini" />
                    </button>
                  </div>
                ) : ("")}

                <div
                  style={{ marginTop: "20px" }}
                  onClick={() =>
                    backUrl ? history.push(backUrl) : history.goBack()
                  }>
                  <a>
                    {/* <i className="fa fa-angle-left" /> */}
                    {/* <i className="fa fa-angle-left" /> */}
                    {"<< "}
                    &nbsp;
                    &nbsp;
                    {backBtnText}
                  </a>
                </div>
              </div>

              {children}

            </div>
          </Navbar.Brand>
          <Navbar.Toggle onClick={mobileSidebarToggle} />
        </Navbar.Header>
      </Navbar>
    </div>
  );
};

export default withRouter(SuperpositionHeader);
